import React from "react";

import App from "./App";

import {
  EthereumClient,
  w3mConnectors,
  w3mProvider,
} from "@web3modal/ethereum";
import { Web3Modal } from "@web3modal/react";
import { configureChains, createClient, WagmiConfig } from "wagmi";
import { bsc, mainnet } from "wagmi/chains";
import { AppContextProvider } from "./utils";

const chains = [bsc, mainnet];
const projectId = "2dde3c8c4b1b6b90a8787238c249a57f";
const { provider, webSocketProvider } = configureChains(chains, [
  w3mProvider({ projectId }),
]);
const wagmiConfig = createClient({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, version: 1, chains }),
  provider,
  webSocketProvider,
});
const ethereumClient = new EthereumClient(wagmiConfig, chains);

const Main = () => {
  return (
    <>
      <WagmiConfig client={wagmiConfig}>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </WagmiConfig>
      <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
    </>
  );
};

export default Main;
